import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=9da95382&scoped=true&"
import script from "./CarInfo.vue?vue&type=script&lang=js&"
export * from "./CarInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=9da95382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da95382",
  null
  
)

export default component.exports